import styled from 'styled-components';
import { AvatarProps } from '.';

const Content = styled.div<AvatarProps>`
    width: fit-content;
    display: flex;
    
    ${(props) =>
        !!props.margin &&
        `
      margin: ${props.margin};
  `}

    ${(props) =>
        !!props.onClick &&
        `
     cursor: pointer;
  `}

  & svg, img {
        width: ${(props) => (!props.size ? '40px' : `${props.size}px`)};
        height: ${(props) => (!props.size ? '40px' : `${props.size}px`)};
        border-radius: 50%;
    }
`;

export { Content };
